class Token {
    tokenType: string = "";
    accessToken: any = "";

    constructor(token?:any) {
        if(token!== undefined) {
            this.tokenType=token.token_type
            this.accessToken=token.access_token
        }
    }
}

export default Token;